export function phoneValidate(phone: string) {
  return (
    phone.replaceAll(/[()_ -]/g, '').length > 10 &&
    phone.replaceAll(/[()_ -]/g, '').length < 13
  )
}
